<template>
  <b-dropdown
    id="font-color-picker"
    class="icon-btn"
    variant="outline-primary"
    :disabled="this.disabled"
    @show="collapseShow"
    @hide="collapseHide"
  >
    <template slot="button-content">
      <font-awesome-icon v-bind:style="{ color }" :icon="['fas', 'font']" />
    </template>
    <div class="color-picker">
      <color-picker
              theme="light"
        v-if="showFontColorPicker"
        :sucker-hide="true"
        :color="color"
        :colors-history-key="colorHistoryKey"
        :colors-default="colorsDefault"
        @changeColor="changeColor"
      />
    </div>
  </b-dropdown>
</template>

<script>
import colorPicker from '@caohenghu/vue-colorpicker'
import {ActionType} from './actionType'
import axios from 'axios'
import { ENTRYPOINT } from '../../../config/entrypoint'
export default {
  components: {
    colorPicker
  },
  props: {
    fontColor: {
      type: String,
      default: '#000'
    },
    colorHistoryKey: {
      type: String,
      default: ''
    },
    colorsDefault: {},
    fontColorHistory: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      actionType: ActionType.FONT_COLOR,
      showFontColorPicker: false,
      color: ''
    }
  },
  mounted () {
    this.color = this.fontColor
  },
  methods: {
    toRgbaString (color) {
      const { r, g, b, a } = color.rgba
      return `rgba(${r}, ${g}, ${b}, ${a})`
    },
    changeColor (value) {
      this.color = this.toRgbaString(value)
      this.$emit('change', this.actionType, this.toRgbaString(value))
    },
    collapseShow (bvEvent) {
      this.showFontColorPicker = true
    },
    collapseHide (bvEvent) {
      this.showFontColorPicker = false

      var color = this.color
      var payload = {
        color: color,
        type: 'schemaFont'
      }

      if (color) {
        const resp = axios({ url: ENTRYPOINT + '/api/set-user-color', data: payload, method: 'POST' })
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/schemaFonctionnel/ui/fontColorUI.vue